import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { EduUsersListTable } from "./edu-users-list-table";
import { EduUsersAdd } from "./edu-users-add";
import EduUsersView from "./edu-users-view";
import { EduUsersEditAdmin } from "./edu-users-edit-admin";
import { EduUsersEditUser } from "./edu-users-edit-user";
import { handleTokenExpiration } from "../../Component/utils/toast";
import { toast, Bounce } from "react-toastify";

export const EduUsersList = () => {
  const navigate = useNavigate();
  let loginUser = {};
  try {
    loginUser = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
  }
  const [userType, setUserType] = useState(loginUser?.user_type);
  const [archivedVal, setArchivedVal] = useState("Archived");
  const [userCount, setUserCount] = useState(0);
  const [adminCount, setAdminCount] = useState(0);
  const [archivecount, setArchiveCount] = useState(0);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [activateEduUserAdd, setActivateEduUserAdd] = useState(false);
  const [activateEduUserEdit, setActivateEduUserEdit] = useState(false);
  const [editUserType, setEditUserType] = useState(""); // "user" or "admin"
  const [showList, setShowList] = useState(true);
  const [userData, setUserData] = useState({});
  const [tabSelected, setTabSelected] = useState("user");

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        navigate("/login");
        return;
      }

      try {
        const response = await axios.get(`${baseUrl}/user_count/`, {
          headers: {
            Authorization: "Token " + token,
          },
        });

        const data = response.data;

        const users = data.data;
        setUserCount(users.user_count);
        setAdminCount(users.admin_count);
        setArchiveCount(users.archive_count);
      } catch (error) {
        console.error("Error fetching user data:", error);


        if (handleTokenExpiration(error, navigate)) {
          return;
        }

        toast.error("Failed to fetch user data", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        });
      }
    };

    fetchUsers();
  }, [navigate]);

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="d-flex w-full flex-row align-items-center justify-content-between">
            <div>
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <i className="fa fa-users me-2" />
                  {tabSelected === "user"
                    ? "Users List"
                    : tabSelected === "admin"
                    ? "Admin List"
                    : "Archived List"}
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/"> Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {tabSelected === "user"
                        ? "Users List"
                        : tabSelected === "admin"
                        ? "Admin List"
                        : "Archived List"}
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            {tabSelected !== "archive" &&
              ((userType === "SUPER_ADMIN" && tabSelected === "admin") ||
                (userType !== "SUPER_ADMIN" &&
                  tabSelected !== "admin" &&
                  !(
                    userType === "CLEANING_MANAGER" &&
                    tabSelected === "cleaning_manager"
                  ))) && (
                <Link
                  role="button"
                  className="blu-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#add-user"
                  onClick={() => setActivateEduUserAdd(true)}
                >
                  <i className="fa fa-plus me-2" />
                  Add
                </Link>
              )}
          </div>
        </div>

        <div className="col-lg-12">
          <div className="cstm-tab">
            <ul className="nav" id="myTab">
              <li className="nav-item">
                <button
                  className={`nav-link${
                    tabSelected === "user" ? " active" : ""
                  }`}
                  data-bs-toggle="tab"
                  data-bs-target="#tab-01"
                  type="button"
                  role="tab"
                  onClick={() => setTabSelected("user")}
                >
                  Users &nbsp; ({userCount})
                </button>
              </li>
              {userType !== "CLEANING_MANAGER" && userType !== "CLIENT" ? (
              <li className="nav-item">
                <button
                  className={`nav-link${
                    tabSelected === "admin" ? " active" : ""
                  }`}
                  data-bs-toggle="tab"
                  data-bs-target="#tab-02"
                  type="button"
                  id="adminButton"
                  role="tab"
                  onClick={() => setTabSelected("admin")}
                >
                  Admin ({adminCount})
                </button>
              </li>
              ) : (
                <>
                  {userType === "CLEANING_MANAGER" && (
                    <li className="nav-item">
                      <button
                        className={`nav-link${
                          tabSelected === "cleaning_manager" ? " active" : ""
                        }`}
                        data-bs-toggle="tab"
                        data-bs-target="#tab-04"
                        type="button"
                        role="tab"
                        onClick={() => setTabSelected("cleaning_manager")}
                      >
                        Cleaning Manager
                      </button>
                    </li>
                  )}
                  {userType === "CLIENT" && (
                    <li className="nav-item">
                      <button
                        className={`nav-link${
                          tabSelected === "client" ? " active" : ""
                        }`}
                        data-bs-toggle="tab"
                        data-bs-target="#tab-05"
                        type="button"
                        role="tab"
                        onClick={() => setTabSelected("client")}
                      >
                        Client
                      </button>
                    </li>
                  )}
                </>
              )}
              <li className="nav-item">
                <button
                  className={`nav-link${
                    tabSelected === "archive" ? " active" : ""
                  }`}
                  data-bs-toggle="tab"
                  data-bs-target="#tab-03"
                  type="button"
                  role="tab"
                  id="archiveButton"
                  onClick={() => setTabSelected("archive")}
                >
                  ARCHIVED &nbsp; ({archivecount})
                </button>
              </li>
            </ul>
            {showList ? (
              <>
                <div className="tab-content" id="myTabContent">
                  <EduUsersListTable
                    userType={userType}
                    archivedVal={archivedVal}
                    setUserData={setUserData}
                    setShowList={setShowList}
                    forceUpdate={forceUpdate}
                    setForceUpdate={setForceUpdate}
                    activateEduUserEdit={activateEduUserEdit}
                    setActivateEduUserEdit={setActivateEduUserEdit}
                    editUserType={editUserType}
                    setEditUserType={setEditUserType}
                    tabSelected={tabSelected}
                    setArchiveCount={setArchiveCount}
                    setAdminCount={setAdminCount}
                    setUserCount={setUserCount}
                  />
                </div>
              </>
            ) : (
              <>
                <EduUsersView
                  userData={userData}
                  setUserData={setUserData}
                  setShowList={setShowList}
                  forceUpdate={forceUpdate}
                  setForceUpdate={setForceUpdate}
                  setActivateEduUserEdit={setActivateEduUserEdit}
                  editUserType={editUserType}
                  setEditUserType={setEditUserType}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <EduUsersAdd
        userType={userType}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        activateEduUserAdd={activateEduUserAdd}
        setActivateEduUserAdd={setActivateEduUserAdd}
      />
      <EduUsersEditAdmin
        userType={userType}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        activateEduUserEdit={activateEduUserEdit}
        setActivateEduUserEdit={setActivateEduUserEdit}
        userData={userData}
        setUserData={setUserData}
        editUserType={editUserType}
      />
      <EduUsersEditUser
        userType={userType}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        activateEduUserEdit={activateEduUserEdit}
        setActivateEduUserEdit={setActivateEduUserEdit}
        userData={userData}
        setUserData={setUserData}
        editUserType={editUserType}
      />
    </section>
  );
};
